import ProgramInfo from '../components/dev/surveys/ProgramInfo';
import ResponseInfo from '../components/dev/surveys/ResponseInfo';
import QuestionInfo from '../components/dev/surveys/QuestionInfo';
import QuestionInfoButton from '../components/dev/surveys/QuestionInfoButton';
import Hover from '../components/Hover.vue';
import MutuallyExclusive from '../directives/MutuallyExclusive';
import intersection from 'lodash/intersection';
import { mapMutations } from 'vuex';
import { h } from 'vue'


export default {
    name: 'survey-page',
    // template: "<div><slot v-bind='slotProperties'><div v-html='questionsTemplate'></div></slot></div>",
    directives: {
        'exclusive': MutuallyExclusive
    },
    components: {
        ProgramInfo,
        ResponseInfo,
        QuestionInfo,
        QuestionInfoButton,
        Hover,
    },
    props: [
        'propsResponse',
        'propsRawResponse',
        'propsProgram',
        'propsSurveyQuestions',
        'propsShowConditions',
        'propsShowQuestionInfo',
        'propsShowDevInfo',
        'propsTerms',
        'trainingSession',
        'surveyType',
        'fetchView',
        'refreshView',
        'user'
    ],
    data: function() {
        return {    
            response: this.propsResponse,
            rawResponse: this.propsRawResponse,
            program: this.propsProgram,
            surveyQuestions: this.propsSurveyQuestions,
            showConditions: this.propsShowConditions,
            showQuestionInfo: this.propsShowQuestionInfo,
            showDevInfo: this.propsShowDevInfo,
            terms: this.propsTerms,
            questionsTemplate: null,
        }
    },
    // custom render for handling slot-based template (self-assessments) and 
    // for handling dynamically loaded templates retrieved
    // via ajax (training, Build the Skills), which include in-DOM vue components/syntax
    render() {
        let vm = this;
        // storing template in questionsTemplate is unique to components that load
        // survey template from ajax request
        if(vm.questionsTemplate) {
            return h(vm.questionsComponent, vm.slotProperties);
        }
        // if not using questionsTemplate, just render the default slot
        else if(this.$slots.default) {
            return h('div', this.$slots.default(vm.slotProperties));
        }
        return h('div', 'Loading...');
    },
    computed: {
        questionVisibility: function () {
            let visibility = new Map();

            if(this.surveyQuestions) {
                Object.keys(this.surveyQuestions).forEach((q) => {
                    const vis = this.showQuestion(q)
                    this.updateResponseValue(q, vis)
                    visibility.set(q, vis);
                })
            }

            return visibility
        },
        slotProperties: function () {
            let vm = this;
            return {
                response: vm.response,
                rawResponse: vm.rawResponse,
                program: vm.program,
                surveyQuestions: vm.surveyQuestions,
                showConditions: vm.showConditions,
                showQuestionInfo: vm.showQuestionInfo,
                showDevInfo: vm.showDevInfo,
                questionVisibility: vm.questionVisibility,
            }
        },
        questionsComponent: function() {
            let vm = this;

            return {
                name: 'survey-questions',
                template: vm.questionsTemplate,
                props: [
                    'response',
                    'rawResponse',
                    'program',
                    'surveyQuestions',
                    'showConditions',
                    'showQuestionInfo',
                    'showDevInfo',
                    'questionVisibility',
                ],
                components: {
                    ProgramInfo,
                    ResponseInfo,
                    QuestionInfo,
                    QuestionInfoButton,
                },
            };
        }
    }, 
    methods: {
        updateResponseValue(questionName, visible) {
            this.surveyQuestions[questionName].variables.forEach(variable => {
                if (!visible) {
                    this.response[variable.name] = null;
                }
            })
        },
        showQuestion(questionName) {
            return this.meetsProgramConditions(questionName) 
                    && this.meetsResponseConditions(questionName) 
                    && this.meetsCustomConditions(questionName)
        },
        meetsProgramConditions(questionName) {
            const conditions = this.showConditions[questionName];
            if (Object.keys(conditions.program).length > 0) {
                for (let attr in conditions.program) {
                    if (typeof this.program[attr] == 'object') {
                        if (intersection(this.program[attr], conditions.program[attr]).length == 0) {
                            return false;
                        }
                    }else if (conditions.program[attr].indexOf(this.program[attr]) == -1) {
                        return false;
                    }
                }
            }
            return true;
        },
        meetsResponseConditions(questionName) {
            const conditions = this.showConditions[questionName];

            if (Object.keys(conditions.response).length > 0) {
                for (let q in conditions.response) {                        
                    for (var i = 0; i < conditions.response[q].length; i++) {
                        if (this.response[q] == conditions.response[q][i]) {
                            return true;
                        }
                    }
                    return false;
                }
            }
            return true;
        },
        meetsCustomConditions(questionName) {
            const conditions = this.showConditions[questionName];
            
            var ret = true;
            if (Object.keys(conditions.custom).length > 0) {
                ret = eval( "("+conditions.custom +")" ).call(this);
                if (ret === -1) {
                    ret = false;
                }
            }
            
            return ret;
        },
        fetchSurveyView() {
            let vm = this;

            // start survey loading
            vm.updateLoadStatus({isQuizLoading: true});

            // FOR TRAINING KNOWLEDGE QUIZZES+EVALUATION
            if(this.trainingSession) {
                axios.get('/training-session/' + vm.trainingSession.id + '/' + vm.surveyType)
                .then(response => {

                    const template = response.data;
     
                    axios.get('/training-session/' + vm.trainingSession.id + '/' + vm.surveyType + '-context')
                    .then(response => {

                        // set response context
                        vm.response = response.data.context.response;
                        vm.rawResponse = response.data.context.rawResponse;
                        vm.program = this.program;
                        vm.surveyQuestions = response.data.context.surveyQuestions;
                        vm.showConditions = response.data.context.showConditions;
                        vm.terms = response.data.context.terms;
                        vm.showQuestionInfo = true;
                        vm.showDevInfo = true;

                        // set questions page template
                        vm.questionsTemplate = "<div>" + template + "</div>";

                        // finish survey loading
                        vm.updateLoadStatus({isQuizLoading: false});
                    });
                });
            } 
            // FOR BUILD THE SKILLS ASSESSMENT
            else if(this.user) {
                axios.get('/build-the-skills/assessment/user/' + vm.user.id)
                .then(response => {

                    const template = response.data;

                    axios.get('/build-the-skills/assessment/user/' + vm.user.id + "/context")
                    .then(response => {

                        // set response context
                        vm.response = response.data.context.response;
                        vm.rawResponse = response.data.context.rawResponse;
                        vm.surveyQuestions = response.data.context.surveyQuestions;
                        vm.showConditions = response.data.context.showConditions;
                        vm.terms = response.data.context.terms;
                        vm.showQuestionInfo = true;
                        vm.showDevInfo = true;

                        vm.questionsTemplate = "<div>" + template + "</div>";
                        vm.updateLoadStatus({isQuizLoading: false});
                    });
                });
            }
        },
        ...mapMutations({
            updateLoadStatus: 'UPDATE_IS_QUIZ_LOADING',
        })
    },
    watch: {
        trainingSession: {
            immediate: true,
            handler: function(newVal, oldVal) {
                if(this.fetchView) {
                    this.fetchSurveyView();
                }
            }
        },
        refreshView: {
            immediate: true,
            handler: function(newVal, oldVal) {
                if(this.fetchView) {
                    this.fetchSurveyView();
                }
            }
        }
    },
    mounted() {
    }
}
